import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Icons from '../../../../../../common/widgets/Icons';
import { CustomerInfoContext } from '../../../../contexts/CustomerInfoContext';
import { resources } from '../../../../resources/resources';

export default function Favorite() {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);

  return (
    <Link
      to="/my-account/wishlist"
      className="btn app-bar-tools-btn app-bar-favorite"
    >
      <span className="btn-icon alerts-count">
        <Icons.Favorite />
        {customerInfo.favoriteProductsCount > 0 && (
          <span>{customerInfo.favoriteProductsCount}</span>
        )}
      </span>
      <span className="btn-text">{translate(resources.menu.favorite)}</span>
    </Link>
  );
}
